import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-internal-hydraulic-permanent-inspection-teaser',
  templateUrl: './internal-hydraulic-permanent-inspection-teaser.component.html',
  styleUrls: ['./internal-hydraulic-permanent-inspection-teaser.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InternalHydraulicPermanentInspectionTeaserComponent {}
